export default "__VITE_ASSET__C4FYdv1B__"